import React from "react"
import HeroText from "./heroText"

const Hero = () => {
  return (
    <section className="wrapper bg-gray">
      <figure className="position-relative">
        <img src="/img/hero.jpg" alt="" style={{ maxHeight: 900 }} />
        <span
          className="position-absolute top-0 start-0 bottom-0 end-0 "
          style={{
            background: "rgba(30,34,40, 0.5",
            width: "100%",
            height: "100%",
            zIndex: 0,
          }}
        ></span>
      </figure>

      <div
        className="container position-absolute d-flex flex-column allign-content-center justify-content-center"
        style={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          zIndex: 2,
          maxHeight: 600,
        }}
      >
        <div className="row d-none d-md-block">
          <HeroText wide={true} />
        </div>
      </div>
    </section>
  )
}

export default Hero
